import React, {useState, useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {ContentHeader} from '@deviceinsight/ng-ui-components';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import {AssetGroup} from '@deviceinsight/ng-ui-api-client';
import {UpdateJob} from './types';
import './types';
import {fetchJob} from '../../api/updateJobsApi';
import {ADMIN_CREATE_JOB_VARIANT_CONFIGS, JOB_STATUS, DELETE_JOB} from './consts';
import JobVariantDetails from './details/JobVariantDetails';
import JobDetailsDetails from './details/JobDetailsDetails';
import JobDeleteButtonAndModal from './details/JobDeleteButtonAndModal';
import './AdminDetail.less';
import hasAuthority from '../common/hasAuthority';
type Props = {
	assetGroup: AssetGroup;
	match: {
		params: {
			id: string;
		};
	};
} & RouteComponentProps;
const HEADER_TITLE = {
	id: 'assetgroup.detail.updatejob.title',
	defaultValue: 'Firmware Update'
};
export const AdminDetail = ({assetGroup, match: {params}}: Props) => {
	const [job, setJob] = useState<UpdateJob | null | undefined>();
	const [loading, setLoading] = useState<boolean>(false);
	const canDeleteJob = hasAuthority(DELETE_JOB);
	useEffect(() => {
		setLoading(true);
		fetchJob(assetGroup.id, params.id).then((data) => {
			setJob(data);
			setLoading(false);
		});
	}, [assetGroup, params]);
	return (
		<div className="admin-detail">
			<ContentHeader title={HEADER_TITLE} parentPageLink={true} />
			<SpinnerContainer show={loading}>
				<div className="job-update-detail column-wrapper">
					<div className="job-detail-variants column">
						{Object.keys(ADMIN_CREATE_JOB_VARIANT_CONFIGS).map((key) => {
							const config = ADMIN_CREATE_JOB_VARIANT_CONFIGS[key];
							return (
								<React.Fragment key={key}>
									<h2 className="di header dividing">
										<Trans i18nKey={config.name.id}>{config.name.defaultValue}</Trans>
									</h2>
									<JobVariantDetails
										bundleAndVersionData={
											job ? (job as Record<string, any>)[config.key] : undefined
										}
									/>
								</React.Fragment>
							);
						})}
					</div>
					<div className="job-detail-details column">{job && <JobDetailsDetails job={job} />}</div>
				</div>
				<div className="job-update-delete">
					{canDeleteJob && job && job.status === JOB_STATUS.PENDING && (
						<JobDeleteButtonAndModal assetGroupId={assetGroup.id} jobId={job.id} />
					)}
				</div>
			</SpinnerContainer>
		</div>
	);
};
export default withRouter(AdminDetail);
